import React from 'react'

import TopHeader from '../Header/TopHeader'
import Navbar from '../Header/Navbar'
import Crousel from '../Screens/Crousel'
import IncomeTaxReturn from '../Screens/IncomeTaxReturn'
import MapBanner from '../Screens/MapBanner'
import Banner from '../Screens/Banner'
import PopularService from '../Screens/PopularService'
import Footer from '../Footer/Footer'
import Faq from '../Screens/Faq'
import PopularGuide from '../Screens/PopularGuide'

function Main() {
  return (
    <>
      <TopHeader />
      <Navbar />
      <Crousel />
      <IncomeTaxReturn />
      <MapBanner />
      <Banner />
      <PopularService />
      <PopularGuide/>
      <Faq />
      <Footer />

    </>
  )
}

export default Main